import { NavLink, Outlet } from "react-router-dom";
import { KeyRound, Settings, UserCog } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/account", label: "Profile", icon: UserCog, end: true },
  { to: "/account/tokens", label: "API tokens", icon: KeyRound, end: false },
  { to: "/account/preferences", label: "Preferences", icon: Settings, end: false },
];

/**
 * T150 (spec 001 Phase 10) — Account layout with sub-nav.
 *
 * Wraps the three Account/* routes (Profile, API tokens, Preferences) in
 * a shared shell with a tab strip. Mirrors `ProjectLayout`'s nav pattern
 * so the visual language is consistent. Replaces the Stubs.tsx Account
 * placeholder.
 */
export function AccountLayout() {
  return (
    <div className="container max-w-screen-md py-6">
      <nav className="flex items-center gap-1 border-b border-border-muted -mt-2">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cn(
                "inline-flex shrink-0 items-center gap-1.5 h-9 px-2.5 text-sm whitespace-nowrap text-muted-foreground border-b-2 border-transparent hover:text-foreground transition-colors",
                isActive && "text-foreground border-[rgb(var(--of-fg-default))] font-semibold",
              )
            }
          >
            <t.icon className="h-3.5 w-3.5" />
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
